import Bowser from 'bowser';

const browser = Bowser.parse(window.navigator.userAgent);

export const isChrome = (browser.browser.name || '').includes('Chrome');
export const isFirefox = (browser.browser.name || '').includes('Firefox');
export const isSafari = (browser.browser.name || '').includes('Safari');
